














































































































































































































































































































import { Component, Vue, PropSync, Prop, Watch, Ref } from 'vue-property-decorator';
import { validateType } from '@/components/UI/Form/Validations';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { SmartQuery } from 'vue-apollo-decorator';
import { generateUID, WithUID } from '@/utils/utils';

import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { ALL_CARS } from '@/queries/Car';
import { GQL_currentUnitCars, GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';
import { ALL_PROJECTS } from '@/queries/Project';
import { GQL_currentUnitProjects, GQL_currentUnitProjects_currentUnit_projects } from '@/queries/__generated__/currentUnitProjects';
import { ALL_DEPARTMENTS } from '@/queries/Department';
import { GQL_currentUnitDepartments, GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';

import MainPaycheckLineTemplateOverwriteEntity from '@/components/MainPaycheckLineTemplate/MainPaycheckLineTemplateOverwriteEntity.vue';
import { GET_WORK_RELATION_PAYCHECK_LINE_TEMPLATES, UPDATE_PAYCHECK_LINE_TEMPLATE } from '@/queries/PaycheckLineTemplate';
import { GQL_updatePaycheckLineTemplateVariables } from '@/queries/__generated__/updatePaycheckLineTemplate';
import { GQL_getWorkRelationPaycheckLineTemplates, GQL_getWorkRelationPaycheckLineTemplates_workRelation, GQL_getWorkRelationPaycheckLineTemplates_workRelation_paycheckLineTemplates } from '@/queries/__generated__/getWorkRelationPaycheckLineTemplates';
import { GQL_PaycheckLineTemplateUpdate } from '@/queries/global';
import EmployeeInformationForm from '@/components/PaycheckLineTemplate/EmployeeInformationForm.vue';
import i18n from '@/i18n';
import SForm from '@/components/UI/Form/SForm.vue';
import { yesNo } from '@/filters/yesNo';
import PermissionService from '@/utils/permission-service';
import { clone } from 'lodash';
import { sort, sortGetter } from '../UI/Table/sorting';

interface IReadonlyByDefault {
  $_editable: boolean;
}

type TemplateLine = WithUID<GQL_PaycheckLineTemplateUpdate & GQL_getWorkRelationPaycheckLineTemplates_workRelation_paycheckLineTemplates> & IReadonlyByDefault

@Component({
  components: {
    MainPaycheckLineTemplateOverwriteEntity,
    EmployeeInformationForm,
  },
})
export default class PaycheckLineTemplateForm extends Vue {
  @SmartQuery({ query: CURRENT_UNIT }) private currentUnit!: GQL_currentUnit_currentUnit;
  @SmartQuery<PaycheckLineTemplateForm, GQL_getWorkRelationPaycheckLineTemplates, {id: string | number}>({
    query: GET_WORK_RELATION_PAYCHECK_LINE_TEMPLATES,
    fetchPolicy: 'network-only',
    variables() { return { id: this.workRelationId } },
    update: data => {
      return data.workRelation!.paycheckLineTemplates.map(line => {
        return {
          ...line,
          carId: line.car ? line.car.id : null,
          projectId: line.project ? line.project.id : null,
          departmentId: line.department ? line.department.id : null,
        };
      });
    },
    result() {
      this.manuallySort(this.sortColumn, this.sortDirecton);
    },
  }) private paycheckLineTemplates!: TemplateLine[];

  @SmartQuery<PaycheckLineTemplateForm, GQL_getWorkRelationPaycheckLineTemplates, {id: string | number}>({
    query: GET_WORK_RELATION_PAYCHECK_LINE_TEMPLATES,
    fetchPolicy: 'network-only',
    variables() { return { id: this.workRelationId } },
    update: data => data.workRelation,
  }) private workRelation!: GQL_getWorkRelationPaycheckLineTemplates_workRelation;

  @SmartQuery<PaycheckLineTemplateForm, GQL_currentUnitCars>({
    query: () => ALL_CARS,
    update: data => data.currentUnit.cars,
  }) private cars?: GQL_currentUnitCars_currentUnit_cars[];

  @SmartQuery<PaycheckLineTemplateForm, GQL_currentUnitProjects>({
    query: ALL_PROJECTS,
    update: data => data.currentUnit.projects,
  }) private projects?: GQL_currentUnitProjects_currentUnit_projects[];

  @SmartQuery<PaycheckLineTemplateForm, GQL_currentUnitDepartments>({
    query: ALL_DEPARTMENTS,
    update: data => data.currentUnit.departments,
  }) private departments?: GQL_currentUnitDepartments_currentUnit_departments[];

  private UPDATE_PAYCHECK_LINE_TEMPLATE = UPDATE_PAYCHECK_LINE_TEMPLATE;
  private yesNo = yesNo;

  @Prop([ String, Number ]) private workRelationId!: string | number;

  private validForm = true;
  @PropSync('dirty', { type: Boolean, default: false }) private dirtyForm!: boolean;

  @Ref() private readonly formRef?: SForm;

  private rules: IRules = {
    quantity: [ { validation: validateType('number'), message: i18n => i18n.t('Error.required', { field: this.t_attr('MainPaycheckLineTemplate', 'quantity') }) } ],
    rate: [ { validation: validateType('number'), message: i18n => i18n.t('Error.required', { field: this.t_attr('MainPaycheckLineTemplate', 'rate') }) } ],
    sum: [
      { validation: validateType('number'), message: i18n => i18n.t('Error.required', { field: this.t_attr('MainPaycheckLineTemplate', 'sum') }) },
      {
        validation: ({ dataValue, formElements, uid }) => {
          if (
            !formElements.rate ||
            !formElements.rate[uid as string] ||
            !formElements.quantity ||
            !formElements.quantity[uid as string]
          ) return true;

          if (
            formElements.rate[uid as string].dataValue.isZero() &&
              formElements.quantity[uid as string].dataValue.isZero()
          ) return true;

          return (
            formElements.quantity[uid as string].dataValue
              .times(formElements.rate[uid as string].dataValue)
              .toDecimalPlaces(2)
              .equals(dataValue)
          );
        },
        message: i18n => i18n.t('MainPaycheckLineTemplate.sumError'),
        triggerBy: [
          ({ withSameUID }) => withSameUID('rate'),
          ({ withSameUID }) => withSameUID('quantity'),
        ],
        type: 'warning',
      },
    ],
  };

  public get formatDataForMutation(): GQL_updatePaycheckLineTemplateVariables {
    return {
      paycheckLineTemplates: this.paycheckLineTemplates.map(line => {
        return {
          ...line,
          $_UID: undefined,
          $_editable: undefined,
          workRelation: undefined,
          workRelationId: line.workRelation!.id,
          mainPaycheckLineTemplate: undefined,
          mainPaycheckLineTemplateId: line.mainPaycheckLineTemplate.id,
          car: undefined,
          project: undefined,
          department: undefined,
        };
      }),
    };
  }

  private get editableLines() {
    return this.paycheckLineTemplates.filter(line => line.$_editable);
  }

  private makeEditable(line: TemplateLine) {
    this.$set(line, '$_editable', true);
  }

  private duplicateTemplate(line: TemplateLine) {
    const newLine = clone(line);
    newLine.id = '';
    newLine.$_UID = generateUID();
    this.paycheckLineTemplates.push(newLine);
    this.makeEditable(newLine);
  }

  private makeAllEditable() {
    this.paycheckLineTemplates.forEach(line => {
      if (line.$_editable) return;

      this.makeEditable(line);
    });
  }

  private sortColumn = 'mainPaycheckLineTemplate.number';
  private sortDirecton = 'asc';

  private manuallySort(column: string, direction: string) {
    this.sortColumn = column;
    this.sortDirecton = direction;

    let getter: sortGetter<TemplateLine> = column;

    if (column === 'altinnDescription') {
      getter = this.printAltinnDescription;
    }
    if (column === 'altinnFordel') {
      getter = this.printAltinnFordel;
    }

    this.paycheckLineTemplates = sort(this.paycheckLineTemplates, getter, direction);
  }

  private printAltinnDescription(line: TemplateLine) {
    if (line.mainPaycheckLineTemplate.taxDeductionVoluntary) return this.$t(`MainPaycheckLineTemplate.taxDeductionVoluntary`) as string;
    if (line.mainPaycheckLineTemplate.taxDeduction) return this.$t(`MainPaycheckLineTemplate.taxDeduction`) as string;
    if (line.mainPaycheckLineTemplate.garnishment) return this.$t(`MainPaycheckLineTemplate.garnishment`) as string;
    if (line.mainPaycheckLineTemplate.garnishmentSamordnet) return this.$t(`MainPaycheckLineTemplate.garnishmentSamordnet`) as string;
    return line.mainPaycheckLineTemplate.altinnDescription ? this.$t(`Altinn.IncomeDescriptions.${line.mainPaycheckLineTemplate.altinnDescription}`) as string : '';
  }

  private printAltinnFordel(line: TemplateLine) {
   return line.mainPaycheckLineTemplate.altinnFordel ? this.$t(`Altinn.Fordels.${line.mainPaycheckLineTemplate.altinnFordel}`) as string : '';
  }

  private paycheckLineTemplateSaved() {
    this.manuallySort(this.sortColumn, this.sortDirecton);
    this.$sMessage.success(this.$t('MainPaycheckLineTemplate.saveSuccess'));
    this.resetFormDirty();
  }

  @Watch('paycheckLineTemplates', { immediate: true })
  private ensureLinesHaveUID() {
    this.paycheckLineTemplates && this.paycheckLineTemplates.forEach(line => {
      if (!line.$_UID) line.$_UID = generateUID();
    });
  }

  public saveAndContinue() {
    if (!this.editable) return false;

    return this.$apollo.mutate({
      mutation: UPDATE_PAYCHECK_LINE_TEMPLATE,
      variables: this.formatDataForMutation,
    }).then(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      this.$sMessage.success(i18n.t('Message.saveSuccess'));
      return true;
    }).catch(() => {
      return false;
    });
  }

  private resetFormDirty(): void {
    this.formRef && this.formRef.resetDirty();
  }

  private get editable(): boolean {
    return PermissionService.check('canUpdateUnit');
  }

  private printCar(car: GQL_currentUnitCars_currentUnit_cars): string {
    return `${car.registrationNumber} - ${car.name}`;
  }
}
